import { createAction } from '@reduxjs/toolkit';
const prefix = 'analytics';
export const analyticsActions = {
    setDashboard: createAction(`${prefix}/setDashboard`),
    setQuickView: createAction(`${prefix}/setQuickView`),
    setContext: createAction(`${prefix}/setContext`),
    setPeriod: createAction(`${prefix}/setPeriod`),
    setFilters: createAction(`${prefix}/setFilters`),
    setSettings: createAction(`${prefix}/setSettings`),
    setMeta: createAction(`${prefix}/setMeta`),
    restoreSnapshot: createAction(`${prefix}/restoreSnapshot`),
};
